import api from "./axios"; 

export const getPaymentMethods = async () => {
    try {
      const response = await api.get("/api/v1/customer/payment/methods");
      return response.data;
    } catch (error) {
      console.error(error.response?.data?.message || "Error fetching payment methods.");
    }
  };

  export const getBillingHistory = async () => {
    try {
      const response = await api.get("/api/v1/customer/subscription");
      return response.data;
    } catch (error) {
      console.error(error.response?.data?.message || "Failed to fetch payment methods.");
    }
  };
